import { MouseEvent, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { signOut as firebaseSignOut } from 'firebase/auth';

import { signOut } from 'main/store/common/reducer';
import { selectUser } from 'main/store/common/selectors';
import { auth } from 'main/utils/firebase';

export const MemberMenu = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleLogoutMenuClick = useCallback(async () => {
        handleClose();
        await firebaseSignOut(auth);
        navigate('/');
        dispatch(signOut());
    }, [handleClose, dispatch, navigate]);

    return user ? (
        <>
            <Button
                color="inherit"
                startIcon={<AccountCircleIcon />}
                endIcon={<ArrowDropDownIcon />}
                onClick={handleClick}
            >
                {user.name}
            </Button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleLogoutMenuClick}>ログアウト</MenuItem>
            </Menu>
        </>
    ) : null
}
